const BASE_URL = import.meta.env.REACT_APP_BASE_URL;

export const searchApi = {
  allSuggestion: async (queryText) => {
    const urlEncodedQuery = encodeURIComponent(queryText);
    const suggestionResponse = await fetch(
      `${BASE_URL}/search/v1/combined/suggest?query=${urlEncodedQuery}`,
    );

    if (suggestionResponse.status !== 200) {
      throw new Error("Unable to hit combined search suggestion API");
    }
    return await suggestionResponse.json();
  },
  allAutocomplete: async (queryText) => {
    const urlEncodedQuery = encodeURIComponent(queryText);
    const suggestionResponse = await fetch(
      `${BASE_URL}/search/v1/combined/autocomplete?query=${urlEncodedQuery}`,
    );

    if (suggestionResponse.status !== 200) {
      throw new Error("Unable to hit combined search autocomplete API");
    }
    return await suggestionResponse.json();
  },
  combinedSearch: async (searchParams) => {
    const {
      searchText: query,
      top = 10,
      guidelineFacet = undefined,
      sortBy = "relevance",
      skip = 0,
      searchWithin,
    } = searchParams;

    const searchUrl = new URL(`${BASE_URL}/search/v1/combined`);
    searchUrl.searchParams.append("query", query);
    searchUrl.searchParams.append("top", top);
    // Handle guidelineFacet (string or array)
    if (guidelineFacet) {
      if (Array.isArray(guidelineFacet)) {
        guidelineFacet.forEach((facet) => {
          searchUrl.searchParams.append("guidelineFacet", facet);
        });
      } else {
        searchUrl.searchParams.append("guidelineFacet", guidelineFacet);
      }
    }
    if (searchWithin !== "" && searchWithin) {
      searchUrl.searchParams.append("searchWithin", searchWithin);
    }
    searchUrl.searchParams.append("sortBy", sortBy);
    searchUrl.searchParams.append("skip", skip);

    const searchResponse = await fetch(searchUrl.href);

    if (searchResponse.status !== 200) {
      throw new Error("Unable to hit combined search API");
    }
    return await searchResponse.json();
  },
  drugSearchSuggestion: async (queryText) => {
    const urlEncodedQuery = encodeURIComponent(queryText);
    const suggestionResponse = await fetch(
      `${BASE_URL}/search/v1/drug/suggest?query=${urlEncodedQuery}`,
    );

    if (suggestionResponse.status !== 200) {
      throw new Error("Unable to hit search suggestion API");
    }
    return await suggestionResponse.json();
  },
  drugSearchAutocomplete: async (queryText) => {
    const urlEncodedQuery = encodeURIComponent(queryText);
    const suggestionResponse = await fetch(
      `${BASE_URL}/search/v1/drug/autocomplete?query=${urlEncodedQuery}`,
    );

    if (suggestionResponse.status !== 200) {
      throw new Error("Unable to hit combined search autocomplete API");
    }
    return await suggestionResponse.json();
  },

  drugSearch: async (searchParams) => {
    const { searchText: query, sortBy = "relevance" } = searchParams;

    const searchUrl = new URL(`${BASE_URL}/search/v1/drug`);
    searchUrl.searchParams.append("query", query);
    searchUrl.searchParams.append("sortBy", sortBy);

    const drugSearchResponse = await fetch(searchUrl.href);

    if (drugSearchResponse.status !== 200) {
      throw new Error("Unable to hit drug search API");
    }
    return await drugSearchResponse.json();
  },
};
